import type { ShiftFormManagerDashboard, ShiftFormManagerDashboardFilters } from "../../../shared/shift-production-form/contracts";
import { columnAxis, type ColumnMeasure } from "./analysis-columns";
import { validAnalysisDateRange } from "./analysis-date-range";

export type DailyTrendPoint = { date: string; value: number | null; state: "RECORDED" | "EMPTY" | "MISSING" };
export function buildAnalysisDailyTrend(dashboard: ShiftFormManagerDashboard, filters: ShiftFormManagerDashboardFilters, measure: ColumnMeasure) {
  const range = { dateFrom: filters.dateFrom ?? "", dateTo: filters.dateTo ?? "" };
  const source = dashboard.analytics.dailyTrend;
  const points: DailyTrendPoint[] = [];
  if (!source || !validAnalysisDateRange(range)) return { available: false, points, axis: columnAxis(0), recordedDays: 0 };
  const byDate = new Map(source.map(day => [day.productionDate, day]));
  for (let time = Date.parse(`${range.dateFrom}T00:00:00Z`); time <= Date.parse(`${range.dateTo}T00:00:00Z`); time += 86_400_000) {
    const date = new Date(time).toISOString().slice(0, 10);
    const day = byDate.get(date);
    if (!day?.formCount) { points.push({ date, value: null, state: "EMPTY" }); continue; }
    const quantity = measure.kind === "OUTPUT" ? day.actualOutputs.find(item => item.unit === measure.unit)
      : measure.kind === "WASTE" ? day.wasteEntries.find(item => item.key === measure.key && item.unit === measure.unit) : null;
    const value = measure.kind === "DOWNTIME" ? day.downtimeMinutes
      : quantity?.reportingFormCount === day.formCount ? quantity.value : null;
    points.push({ date, value, state: value === null ? "MISSING" : "RECORDED" });
  }
  return { available: true, points, axis: columnAxis(Math.max(0, ...points.map(point => point.value ?? 0))), recordedDays: points.filter(point => point.state !== "EMPTY").length };
}
